// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-save-header[data-v-795b560c]{text-align:right;padding-bottom:5px;padding-top:5px;margin-right:-5px;margin-left:-5px;background-color:#0d76be}.unstyled[data-v-795b560c]{margin-right:15px;background-color:unset;color:#fff}", ""]);
// Exports
module.exports = exports;
